/**
 * A book picked up in the library has to carry its position and its pose
 * across the route change, so the book page can start the arrival exactly
 * where the library left off instead of playing a second animation from
 * nowhere. One book is in flight at a time, so this is a single slot
 * rather than a context — nothing renders from it, and a re-render in
 * between would only get in the way.
 */
export interface BookLaunch {
    id: string;
    /** Viewport-relative box of the book at the moment it was picked. */
    top: number;
    left: number;
    /** The pose it was lying at, as a transform the arrival interpolates from. */
    transform: string;
}

let pending: BookLaunch | null = null;

export const launchBook = (launch: BookLaunch): void => {
    pending = launch;
};

/** Reads and clears: a launch is good for exactly one arrival. */
export const takeBookLaunch = (id: string): BookLaunch | null => {
    const launch = pending && pending.id === id ? pending : null;
    pending = null;
    return launch;
};
